import { ArrowUp } from "lucide-react";
import { Link } from "react-router-dom";
import { scrollToId } from "@/lib/lenis";

const SERVICES = [
  "Commercial Management",
  "Project Audit",
  "Project Accounting",
  "Final Cost Reporting",
];

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/10 bg-[#0a0a0a]">
      <div className="mx-auto max-w-[1440px] px-5 pb-10 pt-20 md:px-10 md:pt-28">
        <button
          data-testid="footer-brand-button"
          onClick={() => scrollToId("#top")}
          className="group block text-left"
        >
          <span className="flex items-center gap-5">
            <img
              src="/assets/veritas-seal-192.png"
              alt="Veritas Advisory LLP seal"
              className="h-16 w-16 rounded-full border border-[#B79045]/40 object-cover transition-transform duration-700 group-hover:rotate-45 md:h-20 md:w-20"
            />
            <span className="block font-mono text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]">
              Transparency in Numbers. Trust in Every Frame.
            </span>
          </span>
          <span className="mt-4 block font-display text-[13vw] font-medium leading-none tracking-tight text-neutral-100 transition-colors duration-500 group-hover:text-[#D4AF37] sm:text-[9vw] lg:text-[6.5vw]">
            VERITAS <em className="italic">ADVISORY</em> LLP
          </span>
        </button>

        <p className="mt-8 max-w-xl text-sm leading-relaxed text-neutral-400">
          Integrated Commercial, Audit &amp; Accounting Management for the Media
          &amp; Film Industry.
        </p>

        <div className="mt-16 grid grid-cols-1 gap-10 border-t border-white/10 pt-10 md:grid-cols-3">
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Services</p>
            <ul className="mt-5 space-y-3">
              {SERVICES.map((s) => (
                <li key={s}>
                  <button
                    data-testid={`footer-service-${s.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    onClick={() => scrollToId("#services")}
                    className="text-sm text-neutral-300 transition-colors duration-300 hover:text-[#D4AF37]"
                  >
                    {s}
                  </button>
                </li>
              ))}
            </ul>
          </div>
          <div>
            <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-neutral-500">Contact</p>
            <ul className="mt-5 space-y-3 text-sm text-neutral-300">
              <li>Suyog Madhukar Pulekar</li>
              <li>
                <a data-testid="footer-phone-link" href="tel:+918850845977" className="transition-colors duration-300 hover:text-[#D4AF37]">
                  +91 88508 45977
                </a>
              </li>
              <li>
                <a data-testid="footer-email-link" href="mailto:suyog@veritas.co.in" className="transition-colors duration-300 hover:text-[#D4AF37]">
                  suyog@veritas.co.in
                </a>
              </li>
            </ul>
          </div>
          <div className="flex flex-col items-start justify-between gap-8">
            <button
              data-testid="footer-contact-button"
              onClick={() => scrollToId("#contact")}
              className="border border-[#B79045]/60 px-6 py-3 font-mono text-[11px] uppercase tracking-[0.2em] text-[#D4AF37] transition-colors duration-300 hover:bg-[#B79045] hover:text-black"
            >
              Start a Conversation
            </button>
            <button
              data-testid="footer-back-to-top"
              onClick={() => scrollToId("#top")}
              aria-label="Back to top"
              className="flex h-11 w-11 items-center justify-center border border-white/15 text-neutral-400 transition-colors duration-300 hover:border-[#D4AF37] hover:text-[#D4AF37]"
            >
              <ArrowUp size={16} />
            </button>
          </div>
        </div>

        <div className="mt-16 flex flex-col justify-between gap-3 border-t border-white/10 pt-6 md:flex-row md:items-center">
          <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
            © 2026 Veritas Advisory LLP. All rights reserved.
          </p>
          <div className="flex items-center gap-6">
            <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600">
              Transparency in Numbers. Trust in Every Frame.
            </p>
            <Link
              data-testid="footer-goshta-link"
              to="/"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              Goshta
            </Link>
            <Link
              data-testid="footer-admin-link"
              to="/admin"
              className="font-mono text-[10px] uppercase tracking-[0.25em] text-neutral-600 transition-colors duration-300 hover:text-[#D4AF37]"
            >
              Admin
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
